// @ts-nocheck
/* eslint-disable */
export const appChevronRight24Icon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M9 7L15 12.5L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'chevron-right-24' as const
};